export const TOGGLE_MATCH = 'TOGGLE_MATCH';



// WEBPACK FOOTER //
// ./js/actions/ToggleMatch.js